import React, { Component } from 'react';
import MaskedInput from 'react-text-mask';
import { Field, Formik } from 'formik';
import { string, object } from 'yup';
import { FormGroup } from '../forms/FormBootstrap';


class CadastroEndereco extends Component {

    constructor(props) {
        super(props);
        this.state = {
            estados: ['AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MG', 'MS', 'MT', 'PA', 'PB', 'PE', 'PI', 'PR', 'RJ', 'RN', 'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO'],
            municipios: []
        }
        this.validationSchema = object().shape({
            logradouro: string()
                .required("Campo obrigatório"),
            numero: string()
                .required("Campo obrigatório"),
            complemento: string(),
            bairro: string()
                .required("Campo obrigatório"),
            cep: string()
                .required("Campo obrigatório"),
            estado: string()
                .required("Campo obrigatório"),
            codigoMunicipio: string()
                .required("Campo obrigatório"),
        });
    }

    onSubmit(values, actions) {
        const newValues = { ...values, cidade: this.state.nomeMunicipio }
        if (this.props.onSubmit) {
            this.props.onSubmit(newValues, actions);
        } else {
            console.log("No onSubmit prop");
        }
    }

    onEstadoChange(estado) {

        fetch("cadastro/municipios/" + estado).then(
            response => {
                response.json().then(data => {
                    this.setState({ municipios: data });
                })

            });
    }

    onMunicipioChange(evt) {
        this.setState({
            nomeMunicipio: evt.target.options[evt.target.selectedIndex].text
        });
    }

    render() {
        return <Formik
            onSubmit={(values, actions) => { this.onSubmit(values, actions) }}
            initialValues={{
                logradouro: '',
                numero: '',
                complemento: '',
                bairro: '',
                cep: '',
                estado: '',
                codigoMunicipio: ''
            }}
            validationSchema={this.validationSchema}
            render={(props) => {
                const {
                    values,
                    touched,
                    errors,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                } = props;

                return (
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <FormGroup className="form-group col-sm-6 col-sm-offset-3" errors={errors} touched={touched} campo="logradouro">
                                <label htmlFor="logradouro">Endereço</label>
                                <input type="text" className="form-control" id="logradouro" name="logradouro" placeholder="Exemplo: Av. Paulista" onChange={handleChange} onBlur={handleBlur} value={values.logradouro} />
                            </FormGroup>
                            </div>
                        <div className="row">

                            <FormGroup className="form-group col-sm-3 col-sm-offset-3" errors={errors} touched={touched} campo="numero">
                                <label htmlFor="numero">Número</label>
                                <input type="text" className="form-control" id="numero" name="numero" placeholder="0000" onChange={handleChange} onBlur={handleBlur} value={values.numero} />
                            </FormGroup>
                            <FormGroup className="form-group col-sm-3" errors={errors} touched={touched} campo="complemento">
                                <label htmlFor="complemento">Complemento</label>
                                <input type="text" className="form-control" id="complemento" name="complemento" placeholder="Apto 603" onChange={handleChange} onBlur={handleBlur} value={values.complemento} />
                            </FormGroup>
                        </div>
                        <div className="row">
                            <FormGroup className="form-group col-sm-4 col-sm-offset-3" errors={errors} touched={touched} campo="bairro">
                                <label htmlFor="bairro" data-balloon-pos="right">Bairro ou distrito</label>
                                <input type="text" className="form-control" id="bairro" name="bairro" placeholder="Exemplo: Centro" onChange={handleChange} onBlur={handleBlur} value={values.bairro} />
                            </FormGroup>

                            <FormGroup className="form-group col-sm-2" errors={errors} touched={touched} campo="cep">
                                <label htmlFor="cep" data-balloon-pos="right">CEP</label>
                                <MaskedInput type="text" className="form-control" id="cep" name="cep" placeholder="00000-000" mask={[/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]} onChange={handleChange} onBlur={handleBlur} value={values.cep} />
                            </FormGroup>
                        </div>
                        <div className="row">
                            <FormGroup className="form-group col-sm-1 col-sm-offset-3" errors={errors} touched={touched} campo="estado">
                                <label htmlFor="estado">Estado</label>
                                <select className="form-control" component="select" id="estado" name="estado" defaultValue={values.estado} onBlur={handleBlur} onChange={(evt) => { var estado = evt.target.value; handleChange(evt); this.onEstadoChange(estado); }} >
                                    <option value=""></option>
                                    {this.state.estados.map((estado) => <option key={estado} value={estado}>{estado}</option>)}
                                </select>
                            </FormGroup>
                            <FormGroup className="form-group col-sm-5" errors={errors} touched={touched} campo="codigoMunicipio">
                                <label htmlFor="codigoMunicipio">Município</label>
                                <Field component="select" className="form-control" id="codigoMunicipio" name="codigoMunicipio" onChange={(evt) => { this.onMunicipioChange(evt); handleChange(evt) }}>
                                    <option value=""></option>
                                    {this.state.municipios.map((municipio) => <option key={municipio.id} value={municipio.id}>{municipio.nome}</option>)}
                                </Field>
                            </FormGroup>
                        </div>


                        <div className="row">
                            <div className="form-group col-sm-6 col-sm-offset-3">
                                <button type="submit" className="btn btn-success pull-right">Avançar &gt;</button>
                            </div>
                        </div>
                    </form>
                )
            }
            }
        />;
    }
}

export default CadastroEndereco;